import { PaymentModalProps } from "./types";
import Modal from "../Modal";
import PaymentMethod from "./PaymentMethod";
import { StyledPaypalLoader } from "./style";

function PaymentModal({
  headerText,
  headerColor,
  headerSize,
  text,
  textColor,
  textSize,
  closeModal,
  checkoutWithCard,
  paypalClicked,
  processingPaypal,
  modalColor,
  modalBorderColor,
  buttonColor,
  preview,
  fontFamily,
}: PaymentModalProps) {
  return (
    <Modal
      title={headerText}
      titleColor={headerColor}
      titleSize={headerSize}
      subtitle={text}
      subtitleColor={textColor}
      subtitleSize={textSize}
      closeModal={closeModal}
      modalColor={modalColor}
      modalBorderColor={modalBorderColor}
      fontFamily={fontFamily}
      style={
        preview
          ? {
              height: "100%",
              width: "100%",
              position: "absolute",
            }
          : {
              height: "100vh",
              width: "100vw",
              position: "fixed",
            }
      }
    >
      <PaymentMethod
        buttonText='Credit or debit card'
        paymentMethods={[
          "https://media.appcharge.com/defaults/apple_pay.svg",
          "https://media.appcharge.com/defaults/google_pay.svg",
          "https://media.appcharge.com/defaults/visa.svg",
          "https://media.appcharge.com/defaults/master_card.svg",
        ]}
        checkoutWithCard={checkoutWithCard}
        currency='usd'
        buttonColor={buttonColor}
      />
      <PaymentMethod
        buttonText='e-Wallet'
        buttonColor={buttonColor}
        className='border-bottom'
        paymentMethods={[
          "https://media.appcharge.com/defaults/e_wallet_1.svg",
          "https://media.appcharge.com/defaults/e_wallet_2.svg",
          "https://media.appcharge.com/defaults/e_wallet_3.svg",
          "https://media.appcharge.com/defaults/e_wallet_4.svg",
        ]}
        checkoutWithCard={checkoutWithCard}
        currency='eur'
      />
      {processingPaypal ? (
        <StyledPaypalLoader>
          <img
            alt='loader'
            src='https://media.appcharge.com/defaults/paypal_loader.gif'
          />
        </StyledPaypalLoader>
      ) : (
        <img
          onClick={paypalClicked}
          className='button'
          alt='paypal payment'
          src='https://media.appcharge.com/defaults/paypal_button.png'
        />
      )}
    </Modal>
  );
}

export default PaymentModal;
